<!-- Top Progress Loader -->
<ngx-loading-bar
  class="loader-bg"
  [includeSpinner]="true"
  [height]="'3px'"
></ngx-loading-bar>

<app-loader></app-loader>

<app-header></app-header>
<main class="ds-route-shell">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>

<app-cookie-consent></app-cookie-consent>
